// Single source of truth for the default colorway: the slot palette painted
// when the user has neither a fabric library nor an explicit colorway. Both
// block_svg.ts (single-block render, swatch UI) and layout.ts (group A in
// the per-group palette table) resolve to this map, so the swatches under a
// rendered block promise the same hexes the rendered quilt actually paints
// (LOOM_012). Layout's B/C/D layer their distinguishing palettes on top —
// group A IS the default, by intent.
export const DEFAULT_COLORWAY: Record<string, string> = {
  center: "#d9b48a",
  points: "#efe7d2",
  background: "#5d7a5e",
  light: "#f0e0c0",
  dark: "#4a3010",
  chain: "#d9b48a",
  bow: "#d9b48a",
  stroke: "#222222",
}
